import { GetterTree } from 'vuex';
import { AdminSiteState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<AdminSiteState, RootState> = {};
